<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-3xl">
    <p class="mb-6">
      <a
        routerLink="/admin"
        class="text-sm text-dusk hover:text-parchment hover:underline"
        >&larr; Back to admin dashboard</a
      >
    </p>

    <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
      >Site admin</span
    >
    <h1 class="mb-8 font-display text-3xl font-semibold text-parchment">Plan limits</h1>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else {
      <div class="flex flex-col gap-6">
        @for (row of rows(); track row.plan) {
          <div class="rounded-md border border-hairline bg-panel p-6">
            <h2 class="font-display text-lg font-semibold text-parchment">
              {{ planLabel(row.plan) }}
            </h2>

            <form
              [formGroup]="row.form"
              (ngSubmit)="save(row)"
              class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3"
            >
              <label class="flex flex-col gap-1 text-sm">
                <span class="text-dusk">Max contestants</span>
                <input
                  formControlName="maxContestants"
                  type="number"
                  class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
                />
              </label>
              <label class="flex flex-col gap-1 text-sm">
                <span class="text-dusk">Max active competitions</span>
                <input
                  formControlName="maxActiveCompetitions"
                  type="number"
                  class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
                />
              </label>
              <label class="flex flex-col gap-1 text-sm">
                <span class="text-dusk">Max achievements</span>
                <input
                  formControlName="maxAchievements"
                  type="number"
                  class="rounded border border-hairline bg-ink px-3 py-2 text-parchment focus:border-gold focus:outline-none"
                />
              </label>

              <div class="col-span-full mt-1 flex items-center gap-3">
                <button
                  type="submit"
                  [disabled]="row.saving() || row.form.invalid"
                  class="inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {{ row.saving() ? 'Saving…' : 'Save' }}
                </button>
                @if (row.saved()) {
                  <span class="text-xs text-gold">Saved.</span>
                }
              </div>

              @if (row.saveError()) {
                <p
                  class="col-span-full rounded border border-wax/40 bg-wax/10 px-3 py-2 text-xs text-parchment"
                >
                  {{ row.saveError() }}
                </p>
              }
            </form>
          </div>
        }
      </div>
    }
  </div>
</section>
